import type { Transition, Variants } from 'framer-motion';

export const MOTION_EASE: [number, number, number, number] = [0.22, 1, 0.36, 1];

export const APP_SPRING: Transition = {
    type: 'spring',
    stiffness: 280,
    damping: 26,
    mass: 0.9,
};

export const APP_SPRING_GENTLE: Transition = {
    type: 'spring',
    stiffness: 210,
    damping: 24,
    mass: 0.95,
};

export const APP_FADE: Transition = {
    duration: 0.28,
    ease: MOTION_EASE,
};

export const pageContentVariants: Variants = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
};

export const slideFadeVariants: Variants = {
    initial: { opacity: 0, x: 28 },
    animate: {
        opacity: 1,
        x: 0,
        transition: {
            duration: 0.34,
            ease: MOTION_EASE,
        },
    },
    exit: {
        opacity: 0,
        x: -22,
        transition: {
            duration: 0.24,
            ease: MOTION_EASE,
        },
    },
};

export const surfaceEntranceVariants: Variants = {
    initial: { opacity: 0, y: 18, scale: 0.98 },
    animate: {
        opacity: 1,
        y: 0,
        scale: 1,
        transition: {
            duration: 0.32,
            ease: MOTION_EASE,
        },
    },
    exit: {
        opacity: 0,
        y: 10,
        scale: 0.98,
        transition: {
            duration: 0.2,
            ease: MOTION_EASE,
        },
    },
};

export const sectionStaggerVariants: Variants = {
    initial: {},
    animate: {
        transition: {
            staggerChildren: 0.06,
            delayChildren: 0.04,
        },
    },
};

export const revealUpVariants: Variants = {
    initial: { opacity: 0, y: 18 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -12 },
};

export const modalBackdropVariants: Variants = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
};

export const modalPanelVariants: Variants = {
    initial: { opacity: 0, y: 24, scale: 0.96 },
    animate: { opacity: 1, y: 0, scale: 1 },
    exit: { opacity: 0, y: 18, scale: 0.97 },
};
